import axios from 'axios';
import { configureHttpHeaders } from './apiHelpers';
import { VITE_USE_MOCK, VITE_MOCK_API, VITE_TOKENIZATION_API } from 'Constants/appEnvConstants'

// eslint-disable-next-line no-undef
const baseUrl = JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_TOKENIZATION_API;

export function getOriginalCardNumber(globalToken) {
  configureHttpHeaders(axios);
  return get(`api/v1/detokenize/${globalToken}`);
}

function get(url) {
  return axios.get(`${baseUrl}${url}`).then(onSuccess).catch(onError);
}

function onSuccess(response) {
  let result;
  if (response.status !== 204) {
    result = response.data;
  } else {
    result = 'Success';
  }
  return result;
}

function onError(error) {
  const returnedError = error && error.response && error.response.data;
  throw returnedError;
}
